/**
 * The source's `apiConfig`, over the platform's single origin.
 *
 * APR runs its API on a separate backend, so `getBackendBaseUrl()` returns an absolute
 * origin that varies between dev and production. The platform serves the SPA and its API
 * from one origin, so the base is empty and the source's
 * `${backendUrl}/APR_Framework_User_Guide.md` resolves same-origin against the assets in
 * `public/`.
 *
 * Kept as a function with the source's name so the screens that call it are unchanged.
 */
export function getBackendBaseUrl(): string {
  return '';
}

export function getApiBaseUrl(): string {
  return '/api/apr';
}
